import React from 'react';
import cn from 'classnames';
import TextRenderer from '@components/TextRenderer';
import { colorMap } from '@constants/colors';
import Actions from '@components/Actions';
import Illustration from '@components/Illustration';
import { SwitchHeroLarge, SwitchHeroSmall } from './Illustrations';
import styles from './SwitchHeroIllustration.module.css';
import DynamicClientLogoMarquee from '@components/Marquee/DynamicClientLogoMarquee';

import textStyles from '@styles/textStyles.module.css';

export const SwitchHeroIllustration = ({
  eyebrow,
  heading,
  claim,
  actions,
  markerColor,
  illustrationColorLight,
  illustrationColorDark,
  clientLogos = [],
}) => {
  return (
    <div
      className={styles.root}
      style={{
        '--marker-color': markerColor && colorMap[markerColor],
      }}
    >
      <div className={styles.top}>
        <div className={styles.foreground}>
          <div className={styles.wrapper}>
            <div className={styles.wrapperInner}>
              <div className={styles.heroText}>
                {eyebrow && (
                  <span className={cn(styles.eyebrow, textStyles.eyebrow)}>
                    {eyebrow}
                  </span>
                )}
                {heading && (
                  <TextRenderer
                    className={cn(textStyles.headlineL, styles.heading)}
                    text={heading}
                    as={'h1'}
                  />
                )}
                {claim && (
                  <TextRenderer
                    className={cn(textStyles.headlineS, styles.claim)}
                    text={claim}
                    as={'h2'}
                  />
                )}
              </div>
              {actions && actions.length > 0 && (
                <Actions actions={actions} className={styles.actions} />
              )}
            </div>
          </div>
        </div>
        <div className={styles.background}>
          <div className={styles.grid}>
            <Illustration illustration="Grid" />
          </div>
          <div className={styles.illustration}>
            <div className={styles.illustrationLarge}>
              <SwitchHeroLarge
                illustrationColorLight={
                  illustrationColorLight && colorMap[illustrationColorLight]
                }
                illustrationColorDark={
                  illustrationColorDark && colorMap[illustrationColorDark]
                }
              />
            </div>
            <div className={styles.illustrationSmall}>
              <SwitchHeroSmall
                illustrationColorLight={
                  illustrationColorLight && colorMap[illustrationColorLight]
                }
                illustrationColorDark={
                  illustrationColorDark && colorMap[illustrationColorDark]
                }
              />
            </div>
          </div>
          <div className={styles.topVignette}></div>
          <div className={styles.leftVignette}></div>
          <div className={styles.bottomVignette}></div>
          <div className={styles.rightVignette}></div>
        </div>
      </div>

      {clientLogos && clientLogos.length > 0 && (
        <DynamicClientLogoMarquee clientLogos={clientLogos} />
      )}
    </div>
  );
};
